export namespace BinTranslations {
  export const common = {
    bin: 'bin',
  } as const;

  export const error = {
    binsUnableToLoadError: 'binsUnableToLoadError',
    binsCannotDeleteWithProductsError: 'binsCannotDeleteWithProductsError',
  } as const;

  export const components = {
    deleteBinModalTitle: 'deleteBinModalTitle',
    deleteBinModalPrimaryText: 'deleteBinModalPrimaryText',
    deleteBinModalWarningText: 'deleteBinModalWarningText',
  } as const;
}
